<template>
	<div>
		<StrapiTable v-bind="table">
			<IPAddressesTableRow
				v-for="i in items"
				:key="i.ip"
				v-bind="i"
				:updating="updatingBlock === i.ip"
				@block="doBlock"
				@unblock="doUnblock"
			/>
		</StrapiTable>
	</div>
</template>

<script>
import StrapiTable from '@/components/admin/StrapiTable'
import IPAddressesTableRow from '@/components/admin/IPAddressesTableRow'
import table from '@/mixins/table'
import tableBlocking from '@/mixins/tableBlocking'

const tableMixin = table([
	{ column: 'ip', label: 'IP address' },
	{ column: 'started', label: 'Sessions started', sort: 'DESC' },
	{ column: 'submitted', label: 'Sessions completed' },
	{ label: 'Actions' }
])

export default {
	name: 'IPAddressesTable',
	mixins: [tableMixin, tableBlocking],
	components: {
		StrapiTable,
		IPAddressesTableRow
	}
}
</script>
